module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Reach4Help","short_name":"Reach4Help","start_url":"/","background_color":"#FFFFFF","theme_color":"#f27979","display":"minimal-ui","icon":"./src/assets/logo.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"78d2063bcc5e542bf67195e3c6fb6fcf"},
    }]
